module.exports = "module.exports = __webpack_public_path__ + \"../../im.html\";";


// WEBPACK FOOTER //
// ./~/html-loader!./~/file-loader/[name].[ext]!./~/extract-loader/lib/extractLoader.js!./~/html-loader!./~/string-replace-loader?search=__STATIC_PATH__&replace=../static&flags=g!./~/string-replace-loader?{"search":"__WEBIM_PLUGIN_VERSION__","replace":"tencent.0.2.213","flags":"g"}!./src/html/im.html